var _mask, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyMember(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#ccc"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6002 24.5579C21.6002 20.4128 15.81 18.651 14.0942 18.651C12.3784 18.651 6.58813 20.4128 6.58813 24.5579C6.58813 25.2615 6.58813 28.3018 6.58813 28.3018H21.6002C21.6002 28.3018 21.6002 25.2615 21.6002 24.5579Z",
    fill: "#CCCCCC",
    stroke: "#CCCCCC",
    strokeWidth: 1.9531
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9142 11.4083C17.9142 13.518 16.2039 15.2283 14.0942 15.2283C11.9845 15.2283 10.2742 13.518 10.2742 11.4083C10.2742 9.29856 11.9845 7.58826 14.0942 7.58826C16.2039 7.58826 17.9142 9.29856 17.9142 11.4083",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9142 11.4083C17.9142 13.518 16.2039 15.2283 14.0942 15.2283C11.9845 15.2283 10.2742 13.518 10.2742 11.4083C10.2742 9.29856 11.9845 7.58826 14.0942 7.58826C16.2039 7.58826 17.9142 9.29856 17.9142 11.4083",
    fill: "#CCCCCC",
    stroke: "#CCCCCC",
    strokeWidth: 1.9531
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyMember);
export default __webpack_public_path__ + "static/media/empty-member.23b9069098eaf06f7e50af68f23c9e8d.svg";
export { ForwardRef as ReactComponent };